import { Col, Row } from 'antd';

import { useLayoutElementsStyles } from '../../components/layout/layoutElements.styles';
import { cssVariables } from '../../styles/cssVariables';
import { pxToNumber } from '../../utils/cssUtils';
import AdminConsoleTitle from './components/AdminConsoleTitle';
import AdminConsoleTemplate from './layout/AdminConsoleTemplate';

export default function AdminSystemSettingsPage() {
  const { styles: layoutStyles } = useLayoutElementsStyles();
  return (
    <AdminConsoleTemplate
      title={
        <AdminConsoleTitle
          titleId="admin.systemSettings.title"
          icon="sliders-h"
        />
      }
    >
      <Row align="top" gutter={pxToNumber(cssVariables.spaceNorm2)}>
        <Col>{}</Col>
        <Col className={layoutStyles.flex1}>TODO</Col>
      </Row>
    </AdminConsoleTemplate>
  );
}
